/**
 * Common IATA airport codes for validation and lookup
 * This is a subset of the most common codes - the parser will accept any 3-letter code
 */

export const COMMON_AIRPORTS = {
  // United States - Major
  'ATL': { name: 'Hartsfield-Jackson Atlanta', city: 'Atlanta', country: 'US' },
  'LAX': { name: 'Los Angeles International', city: 'Los Angeles', country: 'US' },
  'ORD': { name: "O'Hare International", city: 'Chicago', country: 'US' },
  'DFW': { name: 'Dallas/Fort Worth International', city: 'Dallas', country: 'US' },
  'DEN': { name: 'Denver International', city: 'Denver', country: 'US' },
  'JFK': { name: 'John F. Kennedy International', city: 'New York', country: 'US' },
  'SFO': { name: 'San Francisco International', city: 'San Francisco', country: 'US' },
  'SEA': { name: 'Seattle-Tacoma International', city: 'Seattle', country: 'US' },
  'LAS': { name: 'Harry Reid International', city: 'Las Vegas', country: 'US' },
  'MCO': { name: 'Orlando International', city: 'Orlando', country: 'US' },
  'EWR': { name: 'Newark Liberty International', city: 'Newark', country: 'US' },
  'MIA': { name: 'Miami International', city: 'Miami', country: 'US' },
  'PHX': { name: 'Phoenix Sky Harbor', city: 'Phoenix', country: 'US' },
  'IAH': { name: 'George Bush Intercontinental', city: 'Houston', country: 'US' },
  'BOS': { name: 'Boston Logan International', city: 'Boston', country: 'US' },
  'MSP': { name: 'Minneapolis-Saint Paul', city: 'Minneapolis', country: 'US' },
  'DTW': { name: 'Detroit Metropolitan', city: 'Detroit', country: 'US' },
  'PHL': { name: 'Philadelphia International', city: 'Philadelphia', country: 'US' },
  'LGA': { name: 'LaGuardia', city: 'New York', country: 'US' },
  'FLL': { name: 'Fort Lauderdale-Hollywood', city: 'Fort Lauderdale', country: 'US' },
  'BWI': { name: 'Baltimore/Washington', city: 'Baltimore', country: 'US' },
  'DCA': { name: 'Ronald Reagan Washington National', city: 'Washington', country: 'US' },
  'IAD': { name: 'Washington Dulles', city: 'Washington', country: 'US' },
  'SLC': { name: 'Salt Lake City International', city: 'Salt Lake City', country: 'US' },
  'SAN': { name: 'San Diego International', city: 'San Diego', country: 'US' },
  'TPA': { name: 'Tampa International', city: 'Tampa', country: 'US' },
  'AUS': { name: 'Austin-Bergstrom', city: 'Austin', country: 'US' },
  'HNL': { name: 'Daniel K. Inouye', city: 'Honolulu', country: 'US' },
  'PDX': { name: 'Portland International', city: 'Portland', country: 'US' },
  'SJC': { name: 'San Jose International', city: 'San Jose', country: 'US' },
  'OAK': { name: 'Oakland International', city: 'Oakland', country: 'US' },
  'SMF': { name: 'Sacramento International', city: 'Sacramento', country: 'US' },
  'RDU': { name: 'Raleigh-Durham', city: 'Raleigh', country: 'US' },
  'CLT': { name: 'Charlotte Douglas', city: 'Charlotte', country: 'US' },
  'MCI': { name: 'Kansas City International', city: 'Kansas City', country: 'US' },
  'STL': { name: 'St. Louis Lambert', city: 'St. Louis', country: 'US' },
  'SNA': { name: 'John Wayne', city: 'Orange County', country: 'US' },
  'MDW': { name: 'Chicago Midway', city: 'Chicago', country: 'US' },
  'HOU': { name: 'William P. Hobby', city: 'Houston', country: 'US' },
  'DAL': { name: 'Dallas Love Field', city: 'Dallas', country: 'US' },
  'BUR': { name: 'Hollywood Burbank', city: 'Burbank', country: 'US' },

  // International - Major
  'LHR': { name: 'London Heathrow', city: 'London', country: 'UK' },
  'LGW': { name: 'London Gatwick', city: 'London', country: 'UK' },
  'CDG': { name: 'Charles de Gaulle', city: 'Paris', country: 'FR' },
  'ORY': { name: 'Paris Orly', city: 'Paris', country: 'FR' },
  'FRA': { name: 'Frankfurt', city: 'Frankfurt', country: 'DE' },
  'MUC': { name: 'Munich', city: 'Munich', country: 'DE' },
  'AMS': { name: 'Amsterdam Schiphol', city: 'Amsterdam', country: 'NL' },
  'MAD': { name: 'Madrid Barajas', city: 'Madrid', country: 'ES' },
  'BCN': { name: 'Barcelona El Prat', city: 'Barcelona', country: 'ES' },
  'FCO': { name: 'Rome Fiumicino', city: 'Rome', country: 'IT' },
  'MXP': { name: 'Milan Malpensa', city: 'Milan', country: 'IT' },
  'ZRH': { name: 'Zurich', city: 'Zurich', country: 'CH' },
  'VIE': { name: 'Vienna', city: 'Vienna', country: 'AT' },
  'DUB': { name: 'Dublin', city: 'Dublin', country: 'IE' },
  'CPH': { name: 'Copenhagen', city: 'Copenhagen', country: 'DK' },
  'OSL': { name: 'Oslo Gardermoen', city: 'Oslo', country: 'NO' },
  'ARN': { name: 'Stockholm Arlanda', city: 'Stockholm', country: 'SE' },
  'HEL': { name: 'Helsinki-Vantaa', city: 'Helsinki', country: 'FI' },
  'IST': { name: 'Istanbul', city: 'Istanbul', country: 'TR' },
  'DXB': { name: 'Dubai International', city: 'Dubai', country: 'AE' },
  'DOH': { name: 'Hamad International', city: 'Doha', country: 'QA' },
  'AUH': { name: 'Abu Dhabi', city: 'Abu Dhabi', country: 'AE' },
  'SIN': { name: 'Singapore Changi', city: 'Singapore', country: 'SG' },
  'HKG': { name: 'Hong Kong', city: 'Hong Kong', country: 'HK' },
  'NRT': { name: 'Tokyo Narita', city: 'Tokyo', country: 'JP' },
  'HND': { name: 'Tokyo Haneda', city: 'Tokyo', country: 'JP' },
  'ICN': { name: 'Seoul Incheon', city: 'Seoul', country: 'KR' },
  'PEK': { name: 'Beijing Capital', city: 'Beijing', country: 'CN' },
  'PVG': { name: 'Shanghai Pudong', city: 'Shanghai', country: 'CN' },
  'BKK': { name: 'Bangkok Suvarnabhumi', city: 'Bangkok', country: 'TH' },
  'SYD': { name: 'Sydney Kingsford Smith', city: 'Sydney', country: 'AU' },
  'MEL': { name: 'Melbourne', city: 'Melbourne', country: 'AU' },
  'AKL': { name: 'Auckland', city: 'Auckland', country: 'NZ' },
  'YYZ': { name: 'Toronto Pearson', city: 'Toronto', country: 'CA' },
  'YVR': { name: 'Vancouver', city: 'Vancouver', country: 'CA' },
  'YUL': { name: 'Montreal Trudeau', city: 'Montreal', country: 'CA' },
  'MEX': { name: 'Mexico City', city: 'Mexico City', country: 'MX' },
  'CUN': { name: 'Cancun', city: 'Cancun', country: 'MX' },
  'GRU': { name: 'Sao Paulo Guarulhos', city: 'Sao Paulo', country: 'BR' },
  'EZE': { name: 'Buenos Aires Ezeiza', city: 'Buenos Aires', country: 'AR' },
  'SCL': { name: 'Santiago', city: 'Santiago', country: 'CL' },
  'BOG': { name: 'Bogota El Dorado', city: 'Bogota', country: 'CO' },
  'TLV': { name: 'Ben Gurion', city: 'Tel Aviv', country: 'IL' },
  'CAI': { name: 'Cairo', city: 'Cairo', country: 'EG' },
  'JNB': { name: 'Johannesburg O.R. Tambo', city: 'Johannesburg', country: 'ZA' },
  'CPT': { name: 'Cape Town', city: 'Cape Town', country: 'ZA' },
  'NBO': { name: 'Jomo Kenyatta', city: 'Nairobi', country: 'KE' },
  'ADD': { name: 'Bole International', city: 'Addis Ababa', country: 'ET' }
};

/**
 * Check if a string is a valid IATA airport code
 */
export const isValidAirportCode = (code) => {
  if (!code || typeof code !== 'string') return false;
  const normalized = code.toUpperCase().trim();
  // Accept any 3-letter code (parser is permissive)
  return /^[A-Z]{3}$/.test(normalized);
};

/**
 * Get airport info by code
 */
export const getAirportInfo = (code) => {
  if (!code) return null;
  const normalized = code.toUpperCase().trim();
  return COMMON_AIRPORTS[normalized] || null;
};

/**
 * Get display name for airport code
 */
export const getAirportDisplay = (code) => {
  const info = getAirportInfo(code);
  if (info) {
    return `${code} - ${info.city}`;
  }
  return code;
};

/**
 * Extract airport codes from text
 */
export const extractAirportCodes = (text) => {
  if (!text) return [];
  const matches = text.match(/\b[A-Z]{3}\b/g) || [];
  // Filter to known codes first, then include unknowns
  const known = matches.filter(code => COMMON_AIRPORTS[code]);
  const unknown = matches.filter(code => !COMMON_AIRPORTS[code]);
  // Prioritize known codes
  return [...new Set([...known, ...unknown])];
};

export default COMMON_AIRPORTS;
